import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { DashboardAction } from "../actions";
import * as DashboardApi from "../api/dashboard";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherDashboard() {
  yield takeLatest(types.DASHBOARD_LIST_REQUEST, worker);
}

function* worker() {
  try {
    const response = yield call(fetchList);
    let data = response.data;
    yield put(DashboardAction.getSuccess(data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(DashboardAction.getFailure(error.response.data));
  }
}

function fetchList() {
  return DashboardApi.getList();
}
